import classNames from 'classnames';
import React, { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
const SelectorColorLink = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const isDisabled = useMemo(() => !props.isNotAvailableSelectable && !(props === null || props === void 0 ? void 0 : props.isBoutiqueExclusive) && props.disabled, [props.disabled, props.isNotAvailableSelectable, props.isBoutiqueExclusive]);
    return (React.createElement("a", { role: "radio", ref: ref, href: props.item.productUrl, "aria-checked": props.selected, className: classNames('selector__menu__item selector__menu__item--link', isDisabled && 'is-disabled', props.selected && 'selected', props.isInverted && 'inverted'), onClick: (e) => {
            e.preventDefault();
            props.onSelect(props.item);
        }, tabIndex: props.selected ? 0 : -1, onKeyDown: props.onKeyDown, "aria-label": `${props.label} ${isDisabled ? `- ${t('label.outofstock')}` : ''}` },
        React.createElement("span", { "aria-hidden": "true", className: classNames('selector__menu__item__label') },
            props.label,
            props.enableOutofstockLabel && props.isOutOfStock ? ` - ${t('label.outofstock')}` : ''),
        props.children));
});
SelectorColorLink.displayName = 'SelectorColorLink';
export default SelectorColorLink;
